import type { Item } from "../../types/items";

export const SECONDARY_ITEM_CODE_PROFID = "PROFID";
export const SECONDARY_ITEM_CODE_SNAP = "SNAP";

export type SecondaryItem = {
  item: Item;
  thickness: number;
  length: number;
  image: string | null;
};

export type SearchSecondaryItemsResponse = {
  items: SecondaryItem[];
  total: number;
};

export type UpdateSecondaryItemBody = {
  itemId: string;
  thickness: number;
  length: number;
  image?: string | null;
  removeImage?: boolean;
};
